var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { BlockBubble } from '../entities/block-bubble';
var cls = classNames('slice-layout-block-bubble-links');
import { filter } from 'lodash';
import { classNames } from '@shapeable/utils';
import { Grid } from '../elements/grid';
export var SliceBlockBubbleLinksDefaultProps = {};
// -------- Styles -------->
var GridStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var BlockStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding: ", " ", ";\n    flex: 1;\n  "], ["\n    padding: ", " ", ";\n    flex: 1;\n  "])), theme.UNIT(8), theme.UNIT(6))
});
// -------- Components -------->
var My = {
  Container: styled(Grid)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), GridStyles),
  Block: styled(BlockBubble)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["", ""], ["", ""])), BlockStyles)
};
export var SliceBlockBubbleLinks = function (props) {
  var className = props.className,
    entity = props.entity;
  var _a = entity.blocks,
    blocks = _a === void 0 ? [] : _a;
  return React.createElement(My.Container, {
    desktopAutoColumns: 3,
    tabletAutoColumns: 3,
    items: blocks.map(function (block) {
      return React.createElement(My.Block, {
        linkSubject: encodeURIComponent(filter([block.title, block.subtitle, 'Enquiry']).join(' ')),
        key: block.id,
        entity: block
      });
    }),
    className: cls.name(className)
  });
};
SliceBlockBubbleLinks.defaultProps = SliceBlockBubbleLinksDefaultProps;
SliceBlockBubbleLinks.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;